import Navbar from '../Navbar/Navbar';
import Home from '../../pages/Home/Home';
import RegisterRound from '../../pages/RegisterRound/RegisterRound';
import Players from '../../pages/Players/Players';
import Player from '../../pages/Player/Player';
import Rounds from '../../pages/Rounds/Rounds';
import Posts from "../../pages/Posts/Posts";
import CreatePost from "../../pages/CreatePost/CreatePost";
import Login from "../../pages/Login/Login";
import Invites from "../../pages/Admin/Invites";
import Invite from "../../pages/Invite/Invite";
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from "../../AuthContext";
import Info from "pages/Info/Info";

const DEFAULT_LEAGUE_ID = "p7rV0fyVsJqBFtysklEj";

function Applayout() {
    const { user } = useAuth();
    const leagueId = user?.leagueId ?? DEFAULT_LEAGUE_ID;
    return (
        <div className="App">
            <Navbar />

            <div className="main-content">


                <Routes>
                    {/* Redirect root */}
                    <Route path="/" element={<Navigate replace to={`/league/${leagueId}`} />} />

                    {/* Non-league pages */}

                    <Route path="/login" element={<Login />} />
                    <Route path="/invite/:token" element={<Invite />} />

                    {/* League scoped pages */}
                    <Route path="/league/:leagueId/" element={<Home />} />
                    <Route path="/league/:leagueId/players" element={<Players />} />
                    <Route path="/league/:leagueId/player/:playerId" element={<Player />} />
                    <Route path="/league/:leagueId/rounds" element={<Rounds />} />

                    <Route path="/league/:leagueId/posts" element={<Posts />} />
                    <Route path="/league/:leagueId/info" element={<Info />} />

                    {user && (
                        <>
                            <Route path="/league/:leagueId/create-post" element={<CreatePost />} />
                            <Route path="/league/:leagueId/register-round" element={<RegisterRound />} />
                            <Route path="/league/:leagueId/admin/invites" element={<Invites />} />
                        </>
                    )
                    }


                    {/** <Route path="*" element={<Navigate replace to={`/league/${leagueId}`} />} /> */}

                </Routes>
            </div>
            {/**  <Footer />*/}
        </div>
    );
}

export default Applayout;